import { Helmet } from 'react-helmet-async';

const siteUrl = process.env.REACT_APP_SITE_URL || 'https://idgate.in';

const SEOHead = ({
  title,
  absoluteTitle,
  description,
  keywords,
  image,
  imageAlt,
  url,
  type = 'website',
  structuredData,
  noindex = false,
}) => {
  const defaultTitle = 'IDGate | Aadhaar Verification & Digital Check-in for Every Sector';
  const defaultDescription =
    'Aadhaar Digital KYC check-in for hotels, clinics, offices, banks, events and every regulated business in India. Scan QR → UIDAI verifies → one record to your system. Free pilot.';
  const defaultKeywords =
    'Aadhaar verification, Aadhaar eKYC, UIDAI verification, Aadhaar QR verification, digital check-in India, hotel Aadhaar check-in, clinic patient verification India, office visitor management, event entry verification, branch KYC software India, IDGate, DPDP compliant KYC, identity verification India, Aadhaar check-in software';
  const defaultImage = `${siteUrl}/logos/og-image.jpg`;
  const defaultImageAlt = 'IDGate — Aadhaar verification and digital check-in for every sector in India';

  const seoTitle = absoluteTitle || (title ? `${title} | IDGate` : defaultTitle);
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;
  const seoImageAlt = imageAlt || defaultImageAlt;
  const seoUrl = url || siteUrl;
  const robotsContent = noindex ? 'noindex, follow' : 'index, follow';

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="robots" content={robotsContent} />
      <meta name="author" content="IDGate" />
      <link rel="canonical" href={seoUrl} />

      <meta property="og:locale" content="en_IN" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:alt" content={seoImageAlt} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content="IDGate" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@idgate_in" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      <meta name="twitter:image:alt" content={seoImageAlt} />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
